export interface IODocument {
  "@type": string;
  "@rid": string;
  "@version": number;
  "@class": string;
}

export class ODocument implements IODocument {
  "@type" = "d";
  "@rid" = "#-1:-1";
  "@version" = 0;
  "@class": string;

  constructor(name: string) {
    this["@class"] = name;
  }

  isNew(): boolean {
    return this["@rid"] === "#-1:-1";
  }
}
